import axios from 'axios';
import Config from './Config';
import AccessToken from '../actions/AccessToken';

const BASE_URL = Config();
const getResponseEntity = {};
const token = AccessToken();

getResponseEntity.GetEntityList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponseEntity.GetBrandList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponseEntity.AddNewEntity = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponseEntity.UploadMedia = (endpoint, accesstoken, formData, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: formData,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.GetEntityDetails = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponseEntity.EditEntity = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponseEntity.DeleteEntity = (endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.GetDefaultAssignments = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.GetUsersList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.AddDefaultAssignments = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.EditDefaultAssignments = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.DeleteDefaultAssignments = (endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.GetEntities = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.AddEntity = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.GetAttributes = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.AddAttribute = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.DeleteAttribute = (endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.GetContacts = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.GetContactList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.AddContact = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponseEntity.DeleteContact = (endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

export default getResponseEntity;